module.exports = __webpack_public_path__ + "static/media/IlustraciónBannerinicial_2.4899889f.png";